module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index"
  }, [_c('div', {
    staticClass: "centered"
  }, [_c('span', {
    staticClass: "button-wrapper add-meta-tag",
    on: {
      "click": _vm.addNewMetaTag
    }
  }, [_c('a', {
    staticClass: "button is-info"
  }, [_vm._v("+")]), _vm._v("Добавить метатег\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "meta-tags"
  }, _vm._l((_vm.metaTagsData), function(metaTag) {
    return _c('MetaTagItem', {
      key: metaTag.id,
      attrs: {
        "metaTag": metaTag
      }
    })
  }), 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cfc9813a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MetaTags/Index.vue
// module id = 1004
// module chunks = 0